// src/app/store/slices/userSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User, Company } from '@core/types';

interface UserState {
  user: User | null;
  company: Company | null;
  loading: boolean;
}

const initialState: UserState = {
  user: null,
  company: JSON.parse(localStorage.getItem('company') || 'null'),
  loading: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
  setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
      if (action.payload.company_id !== undefined && action.payload.company_id !== null) {
        localStorage.setItem('company_id', String(action.payload.company_id));
      }
    },
    setCompany: (state, action: PayloadAction<Company | null>) => {
      state.company = action.payload;
      if (action.payload) {
        localStorage.setItem('company', JSON.stringify(action.payload));
      } else {
        localStorage.removeItem('company');
      }
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    clearUser: (state) => {
      state.user = null;
      state.company = null;
      localStorage.removeItem('company');
      localStorage.removeItem('company_id');
    },
  },
});

export const { setUser, setCompany, setLoading, clearUser } = userSlice.actions;

export default userSlice.reducer;

